<template>
  <div id="site-header">
    <div
      class="fixed-top"
      id="fixed-header"
      v-bind:style="[
        isdark == true ? { background: 'black' } : { background: 'white' },
      ]"
    >
      <div class="div-lang text-right">
        <div class="container lang-container">
          <v-btn
            @click="changeLanguage(item.id)"
            id="lang-btn"
            text
            class="white--text"
            v-for="item in languages"
            :key="item.id"
          >
            {{ item.langue }}
            <flag :iso="item.flag" class="white-text" :class="['m-2']" />
          </v-btn>
        </div>
      </div>
      <div class="container">
        <nav class="navbar navbar-expand-lg stroke">
          <a class="navbar-brand" href="/">
            <img id="img-logo" :src="image_perso" />
            <span class="evisa">E-visa Cameroun</span>
          </a>
          <button
            class="navbar-toggler collapsed bg-gradient"
            type="button"
            data-toggle="collapse"
            data-target="#navbarTogglerDemo02"
            aria-controls="navbarTogglerDemo02"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon fa icon-expand fa-bars"></span>
            <span class="navbar-toggler-icon fa icon-close fa-times"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
            <ul class="navbar-nav ml-auto">
              <li
                class="nav-item"
                v-bind:class="[currentRouteName == 'Home' ? 'active' : '']"
              >
                <a class="nav-link" href="/">{{ $t("home") }}</a>
              </li>

              <li
                class="nav-item"
                v-bind:class="[currentRouteName == 'Demand' ? 'active' : '']"
                v-if="authenticated"
              >
                <a class="nav-link" href="/demand">{{ $t("dashboard") }}</a>
              </li>
              <li class="nav-item dropdown @@blog__active" v-if="authenticated">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown1"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Support
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown1">
                  <a
                    v-bind:class="[currentRouteName == 'Rdv' ? 'active' : '']"
                    v-if="authenticated"
                    class="dropdown-item @@b__active"
                    href="/rdv"
                    >{{ $t("rdv") }}</a
                  >
                  <a
                    v-bind:class="[
                      currentRouteName == 'Ticket' ? 'active' : '',
                    ]"
                    v-if="authenticated"
                    class="dropdown-item @@bs__active"
                    href="/ticket"
                    >{{ $t("ticket") }}</a
                  >
                  <a
                    v-bind:class="[
                      currentRouteName == 'Edocument' ? 'active' : '',
                    ]"
                    v-if="authenticated"
                    class="dropdown-item @@b__active"
                    href="/edocument"
                    >E-document</a
                  >
                </div>
              </li>

              <li
                class="nav-item"
                v-bind:class="[currentRouteName == 'Contact' ? 'active' : '']"
              >
                <a class="nav-link" href="/contact">Contact</a>
              </li>
              <li
                class="nav-item"
                v-bind:class="[currentRouteName == 'Contact' ? 'active' : '']"
              >
                <a class="nav-link" href="/faq">Faq</a>
              </li>

              <li
                class="nav-item"
                v-bind:class="[currentRouteName == 'Login' ? 'active' : '']"
                v-if="!authenticated"
              >
                <a class="nav-link" href="/login">{{ $t("sign_in") }}</a>
              </li>
             
              <li
                class="nav-item"
                v-bind:class="[currentRouteName == 'Logout' ? 'active' : '']"
                v-if="authenticated"
              >
                <a class="nav-link" @click="logout">{{ $t("logout") }}</a>
              </li>
              
            </ul>
          </div>
          <!-- toggle switch for light and dark theme -->
          <div class="mobile-position">
            <nav class="navigation">
              <div class="theme-switch-wrapper">
                <div>
                  <v-btn text @click="changeTheme" icon>
                    <v-icon size="19" v-if="isdark == true">fas fa-sun</v-icon>
                    <v-icon size="19" v-else>fas fa-moon</v-icon>
                  </v-btn>
                </div>
              </div>
            </nav>
          </div>
          <!-- //toggle switch for light and dark theme -->
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import img from "../../public/logo.png";
import { mapGetters } from "vuex";

export default {
  props: {
    goDark: {
      type: Boolean,
    },
  },
  data() {
    return {
      image_perso: img,
      languages: [
        { id: 0, name: "fr", flag: "fr", langue: "Français" },
        { id: 1, name: "en", flag: "us", langue: "English" },
      ],
    };
  },
  methods: {
    changeTheme() {
      this.$store.dispatch("setdark", !this.isdark);
    },
    changeLanguage(id) {
      this.$store.dispatch("setlanguage", this.languages[id]["name"]);
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
  components: {},
  watch: {
    authenticated(value) {
      if (value === false) {
        this.$router.push("/login");
      }
    },
  },
  created() {
    this.$root.$i18n.locale = this.langLocal;
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    ...mapGetters(["authenticated", "langLocal", "isdark"]),
  },
};
</script>

<style lang="scss" scoped>
.evisa {
  font-size: 18px;
  margin-left: 10px;
  color: rgb(63, 53, 99);
}
#site-header {
  margin-bottom: 100px;
}
#fixed-header {
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.select-form {
  margin-top: -5px;
  width: 50px;
}
#img-logo {
  width: 50px;
  height: 50px;
  border-radius: 100%;
}
#img-logo:hover {
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);
}
.div-lang {
  background-color: rgb(37, 51, 114);
  height: 35px;
  padding: 0px;
}
#lang-btn {
  border: none;
  outline: none;
  font-size: 15px;
}
.lang-container {
  padding: 0px;
  padding-right: 10px;
}

@media (max-width: 990px) {
  .theme-switch-wrapper {
    margin-right: 0px;
    margin-top: -8px;
  }
  .evisa {
    font-size: 16px;
    margin-left: 5px;
  }
  #img-logo {
    width: 40px;
    height: 40px;
  }
  .select-form {
    display: none;
  }
}
</style>
